import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { controlTypes, SpecialFormGroup } from '@utilities/SpecialForms';
import { Location } from '@angular/common';


@Component({
  selector: 'automatic-forms',
  templateUrl: './automatic-forms.component.html',
  styleUrls: ['./automatic-forms.component.scss']
})
export class AutomaticFormsComponent implements OnInit {
  @Input('form') form: SpecialFormGroup;
  @Input('successText') successText: string = '';
  //@Input('cancelText') cancelText: string = 'Reiniciar';
  @Input('cancelText') cancelText: string = '';
  @Input('deleteText') deleteText: string = 'Eliminar';
  @Input('backText') backText: string = '';
  @Input('closeText') closeText: string = '';
  @Input('enableButtons') enableButtons: boolean = true;
  @Input('preRowKey') preRowKey: string;
  @Input() enableBackButton: boolean = true;
  @Input() enableCloseButton: boolean = false;
  @Input() enableSuccessButton: boolean = true;
  @Input('grid') grid: string;
  @Output('enterKey') _enterKey: EventEmitter<any> = new EventEmitter();

  @Output('submit') submit: EventEmitter<any> = new EventEmitter();
  @Output('clean') clean: EventEmitter<any> = new EventEmitter();
  @Output('delete') delete: EventEmitter<any> = new EventEmitter();
  @Output('back') back: EventEmitter<any> = new EventEmitter();
  @Output('arrayDate') arraDate: EventEmitter<any> = new EventEmitter();
  @Output() close: EventEmitter<any> = new EventEmitter();
  @Output() hyperLinkCheck: EventEmitter<any> = new EventEmitter();
  @Output() buttonPressed = new EventEmitter<void>();
  controlTypes = controlTypes;
  blockedDays;

  constructor(private _location:Location ) { }

  ngOnInit() {
  }

  submitAction() {
    this.form.valid ?
      this.submit.emit(this.form.value) :
      this.form.unpristineRequired();
  }

  cancelAction() {
    this.form.specialReset();
    this.clean.emit(this.form.value)
  }

  deleteAction() {
    this.delete.emit(this.form.value)
  }

  goBack() {
    this._location.back();
  }

  closeAction() {
    this.close.next();
  }

  BlockedDaysArray(array){
    this.arraDate.emit(array)
  }

  enterKey(e) {
    this._enterKey.emit(e);
  }

}
